<div class="partners-list-page page-container">
  <div class="flex flex-col gap-6">
    <!-- Header Section -->
    <div class="page-header">
      <h1 class="page-title">Gestión de Partners</h1>
      <p class="page-subtitle">Administra y configura las comisiones de tus colaboradores</p>
    </div>

    <!-- Filters & Stats -->
    <div class="toolbar mb-4">
      <div class="filters-bar">
        <!-- Search -->
        <div class="search-wrapper">
          <fa-icon [icon]="faMagnifyingGlass" class="search-icon"></fa-icon>
          <input
            type="text"
            [ngModel]="searchQuery"
            (ngModelChange)="onSearchChange($event)"
            placeholder="Buscar partners..."
            class="app-input search-input"
          />
        </div>

        <!-- Filters -->
        <div class="select-wrapper">
          <app-custom-select
            [options]="typeOptions"
            [(ngModel)]="typeFilter"
            (selectionChange)="onFilterChange()"
            [small]="true"
            [showIcon]="false"
            placeholder="Tipo de partner"
          ></app-custom-select>
        </div>
        <div class="select-wrapper">
          <app-custom-select
            [options]="relationshipTypeOptions"
            [(ngModel)]="relationshipTypeFilter"
            (selectionChange)="onFilterChange()"
            [small]="true"
            [showIcon]="false"
            placeholder="Modelo de relación"
          ></app-custom-select>
        </div>
        <div class="select-wrapper">
          <app-custom-select
            [options]="statusOptions"
            [(ngModel)]="statusFilter"
            (selectionChange)="onFilterChange()"
            [small]="true"
            [showIcon]="false"
            placeholder="Estado"
          ></app-custom-select>
        </div>
        @if (typeFilter || relationshipTypeFilter || statusFilter) {
          <button
            (click)="clearFilters()"
            class="btn-reset-filters"
            type="button"
            title="Limpiar filtros"
          >
            Limpiar filtros
          </button>
        }
      </div>

      <!-- Quick Stats -->
      <div class="quick-stats flex items-center gap-8 text-sm">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center text-blue-600"
          >
            <fa-icon [icon]="faHandshake"></fa-icon>
          </div>
          <div>
            <div class="text-gray-400 text-[10px] uppercase font-bold tracking-wider leading-none">
              Total
            </div>
            <div class="text-xl font-bold text-gray-900 dark:text-white mt-0.5">
              {{ totalPartners }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Partners Table -->
    <div class="table-card overflow-hidden">
      <div class="table-wrapper">
        <table class="partners-table">
          <thead>
            <tr class="bg-gray-50/50 dark:bg-gray-800/50">
              <th
                class="cursor-pointer hover:text-brand-red transition-colors"
                (click)="onSort('company_name')"
              >
                <div class="flex items-center gap-2">
                  Partner
                  <fa-icon
                    [icon]="getSortIcon('company_name')"
                    class="text-[10px]"
                    [class.text-brand-red]="sortField === 'company_name'"
                  ></fa-icon>
                </div>
              </th>
              <th
                class="text-center cursor-pointer hover:text-brand-red transition-colors"
                (click)="onSort('billing')"
              >
                <div class="flex items-center justify-center gap-2">
                  Facturación (€)
                  <fa-icon
                    [icon]="getSortIcon('billing')"
                    class="text-[10px]"
                    [class.text-brand-red]="sortField === 'billing'"
                  ></fa-icon>
                </div>
              </th>
              <th
                class="text-center cursor-pointer hover:text-brand-red transition-colors"
                (click)="onSort('pipeline')"
              >
                <div class="flex items-center justify-center gap-2">
                  Pipeline (€)
                  <fa-icon
                    [icon]="getSortIcon('pipeline')"
                    class="text-[10px]"
                    [class.text-brand-red]="sortField === 'pipeline'"
                  ></fa-icon>
                </div>
              </th>
              <th
                class="text-center cursor-pointer hover:text-brand-red transition-colors"
                (click)="onSort('opportunities_count')"
              >
                <div class="flex items-center justify-center gap-2">
                  OPS
                  <fa-icon
                    [icon]="getSortIcon('opportunities_count')"
                    class="text-[10px]"
                    [class.text-brand-red]="sortField === 'opportunities_count'"
                  ></fa-icon>
                </div>
              </th>
              <th
                class="cursor-pointer hover:text-brand-red transition-colors"
                (click)="onSort('type')"
              >
                <div class="flex items-center gap-2">
                  Tipo
                  <fa-icon
                    [icon]="getSortIcon('type')"
                    class="text-[10px]"
                    [class.text-brand-red]="sortField === 'type'"
                  ></fa-icon>
                </div>
              </th>
              <th
                class="cursor-pointer hover:text-brand-red transition-colors"
                (click)="onSort('relationship_type')"
              >
                <div class="flex items-center gap-2">
                  Modelo de Relación
                  <fa-icon
                    [icon]="getSortIcon('relationship_type')"
                    class="text-[10px]"
                    [class.text-brand-red]="sortField === 'relationship_type'"
                  ></fa-icon>
                </div>
              </th>
              <th class="text-center">Contrato</th>
              <th
                class="text-center cursor-pointer hover:text-brand-red transition-colors"
                (click)="onSort('company_createdate')"
              >
                <div class="flex items-center justify-center gap-2">
                  Fecha de alta
                  <fa-icon
                    [icon]="getSortIcon('company_createdate')"
                    class="text-[10px]"
                    [class.text-brand-red]="sortField === 'company_createdate'"
                  ></fa-icon>
                </div>
              </th>
              <th
                class="text-center cursor-pointer hover:text-brand-red transition-colors"
                (click)="onSort('last_login_at')"
              >
                <div class="flex items-center justify-center gap-2">
                  Último login
                  <fa-icon
                    [icon]="getSortIcon('last_login_at')"
                    class="text-[10px]"
                    [class.text-brand-red]="sortField === 'last_login_at'"
                  ></fa-icon>
                </div>
              </th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @if (isLoading && partners.length === 0) {
              <tr>
                <td colspan="10" class="py-12 text-center">
                  <div class="flex flex-col items-center gap-3">
                    <div
                      class="w-8 h-8 border-2 border-brand-red border-t-transparent rounded-full animate-spin"
                    ></div>
                    <span class="text-sm text-gray-500 dark:text-gray-400"
                      >Cargando partners...</span
                    >
                  </div>
                </td>
              </tr>
            } @else if (partners.length === 0) {
              <tr>
                <td colspan="10" class="py-12 text-center">
                  <div class="flex flex-col items-center justify-center py-10 text-center px-4">
                    <fa-icon
                      [icon]="faHandshake"
                      class="text-4xl text-gray-200 dark:text-gray-800 mb-3"
                    ></fa-icon>
                    <h3 class="text-base font-semibold text-gray-900 dark:text-white">
                      No se encontraron partners
                    </h3>
                    <p class="text-sm text-gray-500 max-w-xs mx-auto mt-1">
                      Prueba con otros términos de búsqueda.
                    </p>
                  </div>
                </td>
              </tr>
            } @else {
              @for (partner of partners; track partner.id) {
                @if (partner) {
                  <tr
                    class="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors group"
                    [class.row-inactive]="isPartnerInactive(partner)"
                  >
                    <td>
                      <div class="flex items-center gap-2">
                        <a
                          [routerLink]="['/admin/partners', partner.id]"
                          class="partner-name font-bold text-gray-900 dark:text-white hover:text-brand-red transition-colors"
                        >
                          {{ partner.company_name }}
                        </a>
                        @if (isPartnerInactive(partner)) {
                          <span class="status-dot" [title]="partnerStatusLabel(partner)"></span>
                          <span class="text-[9px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 whitespace-nowrap">
                            {{ partnerStatusLabel(partner) }}
                          </span>
                        }
                      </div>
                    </td>
                    <td class="text-center font-bold text-slate-700 dark:text-slate-300">
                      {{ formatCurrency(partner.billing) }}
                    </td>
                    <td class="text-center font-bold text-brand-red">
                      {{ formatCurrency(partner.pipeline) }}
                    </td>
                    <td class="text-center">
                      <span
                        class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400"
                      >
                        {{ partner.opportunities_count || 0 }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider"
                        [ngClass]="{
                          'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400':
                            partner.type,
                          'bg-gray-50 text-gray-600 dark:bg-gray-500/10 dark:text-gray-400':
                            !partner.type
                        }"
                      >
                        {{ partner.type || '-' }}
                      </span>
                    </td>
                    <td>
                      @if (partner.relationship_type) {
                        <span
                          class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-gray-50 text-gray-600 dark:bg-gray-500/10 dark:text-gray-400"
                        >
                          {{ partner.relationship_type }}
                        </span>
                      } @else {
                        <span class="text-gray-300">-</span>
                      }
                    </td>
                    <td class="text-center">
                      @if (getContractStatus(partner) === 'signed') {
                        <span
                          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
                        >
                          Firmado
                        </span>
                      } @else if (getContractStatus(partner) === 'pending') {
                        <span
                          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-amber-50 dark:bg-amber-500/10 text-amber-700 dark:text-amber-400"
                        >
                          Pdte. de firma
                        </span>
                      } @else {
                        <span class="text-gray-300">-</span>
                      }
                    </td>
                    <td class="text-center">
                      @if (partner.company_createdate) {
                        <div class="flex flex-col items-center">
                          <span class="text-xs font-medium text-gray-700 dark:text-gray-300">{{
                            partner.company_createdate | date: 'dd/MM/yyyy'
                          }}</span>
                          <span class="text-[10px] text-gray-400">{{
                            partner.company_createdate | date: 'HH:mm'
                          }}</span>
                        </div>
                      } @else {
                        <span class="text-[10px] text-gray-400 italic">-</span>
                      }
                    </td>
                    <td class="text-center">
                      @if (partner.last_login_at) {
                        <div class="flex flex-col items-center">
                          <span class="text-xs font-medium text-gray-700 dark:text-gray-300">{{
                            partner.last_login_at | date: 'dd/MM/yyyy'
                          }}</span>
                          <span class="text-[10px] text-gray-400">{{
                            partner.last_login_at | date: 'HH:mm'
                          }}</span>
                        </div>
                      } @else {
                        <span class="text-[10px] text-gray-400 italic">Sin actividad</span>
                      }
                    </td>
                    <td class="text-center">
                      <div class="actions-menu-wrapper relative inline-block">
                        <button
                          type="button"
                          (click)="toggleMenu(partner.id, $event)"
                          class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                        >
                          <fa-icon [icon]="faEllipsisVertical"></fa-icon>
                        </button>

                        @if (openMenuId === partner.id && menuPosition) {
                          <div
                            class="dropdown-menu fixed w-48 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-50 py-1 overflow-hidden"
                            [style.top.px]="menuPosition.top"
                            [style.left.px]="menuPosition.left"
                            (click)="$event.stopPropagation()"
                          >
                            <button
                              type="button"
                              class="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors w-full text-left"
                              (click)="openEditModal(partner, $event); closeMenu()"
                            >
                              <fa-icon [icon]="faPen" class="text-gray-400"></fa-icon>
                              Editar partner
                            </button>
                            <a
                              [routerLink]="['/admin/partners', partner.id]"
                              class="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                              (click)="closeMenu()"
                            >
                              <fa-icon [icon]="faEye" class="text-gray-400"></fa-icon>
                              Ver detalle
                            </a>
                            <button
                              type="button"
                              class="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors w-full text-left"
                              (click)="openFilesModal(partner, $event); closeMenu()"
                            >
                              <fa-icon [icon]="faFile" class="text-gray-400"></fa-icon>
                              Documentos
                            </button>
                            <button
                              type="button"
                              class="flex items-center gap-3 px-4 py-2 text-sm transition-colors w-full text-left"
                              [class.text-red-600]="partner.status === 'active'"
                              [class.dark:text-red-400]="partner.status === 'active'"
                              [class.hover:bg-red-50]="partner.status === 'active'"
                              [class.dark:hover:bg-red-900/20]="partner.status === 'active'"
                              [class.text-emerald-600]="partner.status !== 'active'"
                              [class.dark:text-emerald-400]="partner.status !== 'active'"
                              [class.hover:bg-emerald-50]="partner.status !== 'active'"
                              [class.dark:hover:bg-emerald-900/20]="partner.status !== 'active'"
                              [disabled]="updatingStatusId === partner.id"
                              (click)="toggleStatus(partner, $event)"
                            >
                              <fa-icon
                                [icon]="partner.status === 'active' ? faToggleOff : faToggleOn"
                                [class.text-red-500]="partner.status === 'active'"
                                [class.text-emerald-500]="partner.status !== 'active'"
                              ></fa-icon>
                              {{ partner.status === 'active' ? 'Desactivar' : 'Activar' }}
                            </button>
                          </div>
                        }
                      </div>
                    </td>
                  </tr>
                }
              }
            }
          </tbody>
        </table>
      </div>

      @if (isLoadingMore) {
        <div class="py-6 text-center">
          <div
            class="inline-block w-6 h-6 border-2 border-brand-red border-t-transparent rounded-full animate-spin"
          ></div>
        </div>
      }
    </div>
  </div>
</div>

<app-edit-partner-modal
  *ngIf="selectedPartnerForEdit"
  [partner]="selectedPartnerForEdit"
  (close)="closeEditModal()"
  (success)="onEditSuccess($event)"
></app-edit-partner-modal>

<app-partner-files-modal
  *ngIf="selectedPartnerForFiles"
  [partner]="selectedPartnerForFiles"
  (close)="closeFilesModal()"
></app-partner-files-modal>
